import React from 'react';
import Hero from './Hero';
import CTACards from './CTACards';
import FeaturedGrid from './FeaturedGrid';
import CategorySection from './CategorySection';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

const HomeSection: React.FC = () => {
  const { t } = useTranslation();
  return (
    <>
      <Helmet>
        <title>{t('meta.home.title')}</title>
        <meta name="description" content={t('meta.home.description')} />
        <link rel="canonical" href="https://www.u888winbet.com/" />
      </Helmet>
      <Hero />
      <CTACards />
      <FeaturedGrid />
      {/* <CategorySection /> */}
    </>
  );
};

export default HomeSection; 